(() => {
  const mobileViewport = window.matchMedia('(max-width: 989px)');
  const mobileGridViewport = window.matchMedia('(max-width: 749px)');
  const desktopResultsViewport = window.matchMedia('(min-width: 990px)');
  const quickViewContainerSelector =
    '#rebuy-quick-view-dropdown-search .rebuy-quick-view-dropdown__container.visible';
  const quickViewSelectSelector =
    '#rebuy-quick-view-dropdown-search .rebuy-product-options select';
  const quickViewCtaSelector =
    '#rebuy-quick-view-dropdown-search .rebuy-quick-view__product-cta';
  const quickViewSearchSelector =
    '#rebuy-quick-view-dropdown-search .rebuy-quick-view-dropdown__search-input';
  const quickViewRootSelector = '#rebuy-quick-view-dropdown-search';
  const themeSearchTriggerSelector = '.header__search summary.header__icon--search';
  const rebuyResultsPageSelector = '#rebuy-smart-search-results-dropdown';
  const resultsPageSearchSelector =
    '#rebuy-smart-search-results-dropdown .rebuy-smart-search-results-page-dropdown__input';
  const assetScript = document.querySelector('script[src*="rebuy-smart-search.js"]');
  const viewProductLabel = assetScript?.dataset.viewProductLabel ?? '';
  const filterLabel = assetScript?.dataset.filterLabel ?? '';
  const filterButtonLabel = assetScript?.dataset.filterButtonLabel ?? '';
  const filterAndSortLabel = assetScript?.dataset.filterAndSortLabel ?? filterButtonLabel;
  const sortLabel = assetScript?.dataset.sortLabel ?? '';
  const searchPlaceholder = assetScript?.dataset.searchPlaceholder ?? '';
  const clearSearchLabel = assetScript?.dataset.clearSearchLabel ?? '';
  const previousPageLabel = assetScript?.dataset.previousPageLabel ?? '';
  const nextPageLabel = assetScript?.dataset.nextPageLabel ?? '';
  const searchUrl = assetScript?.dataset.searchUrl ?? '/search';
  const buildProductSearchUrl = (searchTerm) =>
    `${searchUrl}?q=${encodeURIComponent(searchTerm)}&type=product&options%5Bprefix%5D=last`;
  const filterIconTemplate = document.querySelector(
    '#rebuy-smart-search-filter-icon-template'
  );
  const searchIconTemplate = document.querySelector(
    '#rebuy-smart-search-search-icon-template'
  );
  const clearIconTemplate = document.querySelector(
    '#rebuy-smart-search-clear-icon-template'
  );
  const gridToggleTemplate = document.querySelector(
    '#rebuy-smart-search-grid-toggle-template'
  );
  const gridPreferenceKey = 'usa-containers-collection-grid-columns';
  const quickViewArticleTitle = 'Resources';
  const resultsArticleTabTitle = 'Resources ({count})';
  const storefrontVariantChecks = new Map();

  const suppressRebuyResultsPage = (root = document) => {
    if (!document.querySelector('[data-native-search-results]')) return;

    const resultsPages = new Set(root.querySelectorAll?.(rebuyResultsPageSelector) ?? []);
    if (root instanceof Element && root.matches(rebuyResultsPageSelector)) resultsPages.add(root);
    resultsPages.forEach((resultsPage) => resultsPage.remove());
  };

  const hideQuickViewAttribution = (root = document) => {
    const quickViewRoot = root.matches?.(quickViewRootSelector)
      ? root
      : root.querySelector?.(quickViewRootSelector) || document.querySelector(quickViewRootSelector);
    if (!quickViewRoot) return;

    quickViewRoot.querySelectorAll('*').forEach((element) => {
      if (element.children.length || element.textContent.trim().toLowerCase() !== 'powered by rebuy') return;
      const attribution = element.closest('a') || element;
      attribution.classList.add('rebuy-smart-search-attribution-hidden');
      attribution.setAttribute('aria-hidden', 'true');
    });
  };

  const isResourceContent = (content) =>
    content?.type === 'article' ||
    /^\/blogs\//.test(content?.url ?? '');

  const replaceArrayContents = (currentItems, nextItems) => {
    if (!Array.isArray(currentItems)) return;

    const isUnchanged =
      currentItems.length === nextItems.length &&
      currentItems.every((item, index) => item === nextItems[index]);
    if (!isUnchanged) currentItems.splice(0, currentItems.length, ...nextItems);
  };

  const prepareResourceContent = () => {
    const smartSearch = window.Rebuy?.SmartSearch;
    const quickViewContent = smartSearch?.quickView?.view?.content;

    if (Array.isArray(quickViewContent)) {
      replaceArrayContents(quickViewContent, quickViewContent.filter(isResourceContent));
    }

    const quickViewContentTitle = document.querySelector(
      '#rebuy-quick-view-dropdown-search .rebuy-quick-view__content-section > .rebuy-quick-view__title'
    );
    if (
      quickViewContentTitle &&
      quickViewContentTitle.textContent.trim() !== quickViewArticleTitle
    ) {
      quickViewContentTitle.textContent = quickViewArticleTitle;
    }

    const resultsPage = smartSearch?.resultsPage;
    const availableContent = resultsPage?.searchResults?.content;
    const displayedContent = resultsPage?.contentSearch?.content;
    if (!Array.isArray(availableContent) || !Array.isArray(displayedContent)) return;

    if (resultsPage.contentSearch.contentTabTitle !== resultsArticleTabTitle) {
      resultsPage.contentSearch.contentTabTitle = resultsArticleTabTitle;
    }

    const configuredContentSearch =
      smartSearch?.globalData?.settings?.searchResultsSettings?.setting?.editorLayout
        ?.contentSearch;
    if (
      configuredContentSearch &&
      configuredContentSearch.contentTabTitle !== resultsArticleTabTitle
    ) {
      configuredContentSearch.contentTabTitle = resultsArticleTabTitle;
    }

    const displayLimit = resultsPage.contentSearch.maxDisplayed ?? 8;
    replaceArrayContents(
      displayedContent,
      availableContent.filter(isResourceContent).slice(0, displayLimit)
    );
  };

  const prepareQuickViewResultsFooter = () => {
    const quickView = window.Rebuy?.SmartSearch?.quickView?.view;
    const overlayBody = document.querySelector(
      '#rebuy-quick-view-dropdown-search .rebuy-quick-view__overlay-body'
    );
    const results = overlayBody?.querySelector('.rebuy-quick-view-dropdown__results');
    const searchTerm = quickView?.searchTerm?.trim() ?? '';
    let footer = overlayBody?.querySelector('.rebuy-quick-view-results-footer');

    if (!overlayBody || !results || !searchTerm) {
      footer?.remove();
      return;
    }

    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'rebuy-quick-view-results-footer';

      const link = document.createElement('a');
      link.className = 'rebuy-quick-view-results-footer__link';

      const label = document.createElement('span');
      label.className = 'rebuy-quick-view-results-footer__label';

      const arrow = document.createElement('span');
      arrow.className = 'rebuy-quick-view-results-footer__arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';

      link.append(label, arrow);
      footer.append(link);
      overlayBody.querySelector('.rebuy-quick-view__container')?.after(footer);
    }

    const link = footer.querySelector('.rebuy-quick-view-results-footer__link');
    const label = footer.querySelector('.rebuy-quick-view-results-footer__label');
    const linkLabel = `View all results for ${searchTerm}`;
    if (label.textContent !== linkLabel) label.textContent = linkLabel;
    link.setAttribute('aria-label', linkLabel);
    link.href = buildProductSearchUrl(searchTerm);
  };

  const getVariantId = (select) => select?.value.match(/\d{10,}/)?.[0] ?? null;

  const checkStorefrontVariant = (variantId) => {
    if (!variantId) return Promise.resolve(null);
    if (storefrontVariantChecks.has(variantId)) return storefrontVariantChecks.get(variantId);

    const request = fetch(`/variants/${encodeURIComponent(variantId)}.json`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (response.ok) return true;
        if (response.status === 404) return false;
        return null;
      })
      .catch(() => null);

    storefrontVariantChecks.set(variantId, request);
    return request;
  };

  const getQuickViewCard = (element) => element.closest('.rebuy-quick-view__product');

  const setQuickViewCtaState = (select, isPurchasable) => {
    const card = getQuickViewCard(select);
    const button = card?.querySelector('.rebuy-quick-view__product-cta');
    if (!button) return;

    if (!button.dataset.addToCartLabel) {
      button.dataset.addToCartLabel = button.textContent.trim();
    }
    if (!('addToCartAriaLabel' in button.dataset)) {
      button.dataset.addToCartAriaLabel = button.getAttribute('aria-label') ?? '';
    }

    button.dataset.storefrontVariantState =
      isPurchasable === true ? 'purchasable' : isPurchasable === false ? 'pdp' : 'unknown';
    button.textContent =
      isPurchasable === false && viewProductLabel
        ? viewProductLabel
        : button.dataset.addToCartLabel;

    if (isPurchasable === false && viewProductLabel) {
      button.setAttribute('aria-label', viewProductLabel);
    } else if (button.dataset.addToCartAriaLabel) {
      button.setAttribute('aria-label', button.dataset.addToCartAriaLabel);
    } else {
      button.removeAttribute('aria-label');
    }
  };

  const syncQuickViewCta = async (select) => {
    const variantId = getVariantId(select);
    const isPurchasable = await checkStorefrontVariant(variantId);
    if (getVariantId(select) === variantId) setQuickViewCtaState(select, isPurchasable);
  };

  const prepareQuickViewCtas = (root = document) => {
    const buttons = new Set(root.querySelectorAll?.(quickViewCtaSelector) ?? []);

    if (root instanceof Element) {
      if (root.matches(quickViewCtaSelector)) buttons.add(root);
      const containingButton = root.closest(quickViewCtaSelector);
      if (containingButton) buttons.add(containingButton);
    }

    buttons.forEach((button) => {
      button.classList.add('quick-add__submit', 'button', 'button--full-width', 'button--secondary');
    });
  };

  const syncQuickViewCtas = (root = document) => {
    const selects = new Set(root.querySelectorAll?.(quickViewSelectSelector) ?? []);

    if (root instanceof Element) {
      if (root.matches(quickViewSelectSelector)) selects.add(root);
      const containingSelect = root.closest(quickViewSelectSelector);
      if (containingSelect) selects.add(containingSelect);
    }

    selects.forEach(syncQuickViewCta);
  };

  const updateResultsCount = (filters, resultsRoot) => {
    const activeTab = resultsRoot.querySelector(
      '.rebuy-smart-search-results-page-dropdown__tab--active'
    );
    const match = activeTab?.textContent.trim().match(/^(.*?)\s*\((\d+)\)$/);
    let count = filters.querySelector(':scope > .rebuy-search-filters__result-count');

    if (!match) {
      count?.remove();
      return;
    }

    if (!count) {
      count = document.createElement('span');
      count.className = 'rebuy-search-filters__result-count';
      filters.append(count);
    }

    const nextText = `${match[2]} ${match[1].trim()}`;
    if (count.textContent !== nextText) count.textContent = nextText;
  };

  const prepareMobileFilterButton = (button) => {
    const content = button?.querySelector('p');
    const icon = filterIconTemplate?.content.querySelector('.icon-filter')?.cloneNode(true);
    if (!content || !icon || !filterAndSortLabel) return;

    if (!content.querySelector('.rebuy-mobile-filter-trigger__label')) {
      const label = document.createElement('span');
      label.className = 'rebuy-mobile-filter-trigger__label';
      label.textContent = filterAndSortLabel;
      icon.setAttribute('aria-hidden', 'true');
      content.replaceChildren(icon, label);
    }
  };

  const prepareQuickViewSearchHeader = (root = document) => {
    const searchInputs = new Set(root.querySelectorAll?.(quickViewSearchSelector) ?? []);

    if (root instanceof Element && root.matches(quickViewSearchSelector)) {
      searchInputs.add(root);
    }

    searchInputs.forEach((searchInput) => {
      const input = searchInput.querySelector('input');
      if (!input) return;

      if (searchPlaceholder) input.placeholder = searchPlaceholder;
      if (!input.id) input.id = 'rebuy-quick-view-search-input';

      let label = searchInput.querySelector('.rebuy-quick-view-dropdown__search-label');
      if (!label) {
        label = document.createElement('label');
        label.className = 'rebuy-quick-view-dropdown__search-label';
        searchInput.append(label);
      }
      label.htmlFor = input.id;
      label.textContent = searchPlaceholder;

      if (!searchInput.querySelector('.icon-search')) {
        const icon = searchIconTemplate?.content.querySelector('.icon-search')?.cloneNode(true);
        if (icon) {
          icon.setAttribute('aria-hidden', 'true');
          searchInput.append(icon);
        }
      }
    });
  };

  const syncResultsSearchClearButton = (input) => {
    const button = input?.parentElement?.querySelector('.rebuy-results-search-clear');
    if (button) button.hidden = !input.value.trim();
  };

  const prepareResultsSearchInput = () => {
    const input = document.querySelector(resultsPageSearchSelector);
    const container = input?.parentElement;
    if (!input || !container) return;

    if (searchPlaceholder) input.placeholder = searchPlaceholder;
    if (!input.id) input.id = 'rebuy-smart-search-results-input';

    let label = container.querySelector('.rebuy-results-search-label');
    if (!label) {
      label = [...document.querySelectorAll('label')].find(
        (candidate) => candidate.htmlFor === input.id && candidate.classList.contains('sr-only')
      );
    }
    if (!label) {
      label = document.createElement('label');
    }
    label.classList.remove('sr-only');
    label.classList.add('rebuy-results-search-label');
    label.htmlFor = input.id;
    label.textContent = searchPlaceholder;
    if (label.parentElement !== container) container.append(label);

    let button = container.querySelector('.rebuy-results-search-clear');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'rebuy-results-search-clear';
      if (clearSearchLabel) button.setAttribute('aria-label', clearSearchLabel);

      const icon = clearIconTemplate?.content.querySelector('.icon-close')?.cloneNode(true);
      if (icon) {
        icon.setAttribute('aria-hidden', 'true');
        button.append(icon);
      }

      container.append(button);
    }

    if (!container.querySelector('.rebuy-results-search-icon')) {
      const icon = searchIconTemplate?.content.querySelector('.icon-search')?.cloneNode(true);
      if (icon) {
        const iconWrapper = document.createElement('span');
        iconWrapper.className = 'rebuy-results-search-icon';
        iconWrapper.setAttribute('aria-hidden', 'true');
        iconWrapper.append(icon);
        container.append(iconWrapper);
      }
    }

    syncResultsSearchClearButton(input);
  };

  const getStoredGridPreference = () => {
    try {
      return localStorage.getItem(gridPreferenceKey);
    } catch (error) {
      return null;
    }
  };

  const setStoredGridPreference = (columns) => {
    try {
      localStorage.setItem(gridPreferenceKey, columns);
    } catch (error) {
      // Grid preference persistence is progressive enhancement only.
    }
  };

  const getProductResultsGrid = (resultsRoot) => {
    const grid = resultsRoot?.querySelector('.rebuy-smart-search-results-page__container');
    return grid?.querySelector(':scope > .rebuy-smart-search-results-page__product')
      ? grid
      : null;
  };

  const setSearchGridColumns = (resultsRoot, columns) => {
    const normalizedColumns = columns === '1' ? '1' : '2';
    const grid = getProductResultsGrid(resultsRoot);
    const toggle = resultsRoot?.querySelector('.rebuy-search-grid-view-toggle');
    if (!grid || !toggle) return;

    grid.dataset.searchMobileColumns = normalizedColumns;
    toggle.querySelectorAll('[data-rebuy-search-grid-columns]').forEach((button) => {
      button.setAttribute(
        'aria-pressed',
        String(button.dataset.rebuySearchGridColumns === normalizedColumns)
      );
    });
  };

  const prepareMobileGridControls = (filters, resultsRoot) => {
    if (!filters || !resultsRoot || !mobileGridViewport.matches) return;

    let toggle = filters.querySelector('.rebuy-search-grid-view-toggle');
    if (!toggle && gridToggleTemplate) {
      toggle = gridToggleTemplate.content.firstElementChild?.cloneNode(true);
      if (toggle) filters.append(toggle);
    }

    if (!toggle) return;

    const grid = getProductResultsGrid(resultsRoot);
    toggle.hidden = !grid;
    if (!grid) return;

    const storedColumns = getStoredGridPreference();
    const columns = storedColumns === '1' || storedColumns === '2' ? storedColumns : '2';
    setSearchGridColumns(resultsRoot, columns);
  };

  const getStickyHeaderOffset = () => {
    const stickyHeader = document.querySelector(
      'sticky-header, .shopify-section-header-sticky, .shopify-section-header'
    );
    if (!stickyHeader) return 0;

    return Math.max(Math.round(stickyHeader.getBoundingClientRect().bottom), 0);
  };

  const updateSearchStickyOffset = () => {
    const resultsRoot = document.querySelector('#rebuy-smart-search-results-dropdown');
    resultsRoot?.style.setProperty('--rebuy-search-sticky-offset', `${getStickyHeaderOffset()}px`);
  };

  const markLiveCollectionFilters = (filterMenu) => {
    filterMenu
      ?.querySelectorAll('.rebuy-filter-select-menu__list-item')
      .forEach((item) => {
        const title = item
          .querySelector('.rebuy-smart-search-results-page-dropdown__filter-list-title')
          ?.textContent.trim()
          .toLowerCase();
        item.dataset.liveCollectionFilter =
          title === 'availability' || title === 'price' ? 'true' : 'false';
      });
  };

  const prepareMobileFilterMenu = (filterMenu, originalSort) => {
    if (!filterMenu || !originalSort) return;

    if (!filterMenu.querySelector('.rebuy-mobile-filter-heading')) {
      const heading = document.createElement('h3');
      heading.className = 'rebuy-mobile-filter-heading';
      heading.textContent = filterAndSortLabel;
      filterMenu.querySelector('.rebuy-filter-select-menu__close')?.after(heading);
    }

    let mobileSort = filterMenu.querySelector('.rebuy-mobile-filter-sort');
    if (!mobileSort) {
      mobileSort = document.createElement('div');
      mobileSort.className = 'rebuy-mobile-filter-sort';

      const label = document.createElement('label');
      label.className = 'rebuy-mobile-filter-sort__label';
      label.htmlFor = 'rebuy-smart-search-mobile-sort-options';
      label.textContent = sortLabel;

      const select = originalSort.cloneNode(true);
      select.id = 'rebuy-smart-search-mobile-sort-options';
      select.classList.add('rebuy-mobile-filter-sort__select');
      select.value = originalSort.value;
      select.addEventListener('change', () => {
        originalSort.value = select.value;
        originalSort.dispatchEvent(new Event('change', { bubbles: true }));
      });

      mobileSort.append(label, select);
      filterMenu.append(mobileSort);
    }

    mobileSort.querySelector('select').value = originalSort.value;
  };

  const prepareResultsFilters = () => {
    const resultsRoot = document.querySelector('#rebuy-smart-search-results-dropdown');
    const filters = resultsRoot?.querySelector('.rebuy-search-filters');
    if (!filters) return;

    resultsRoot.querySelectorAll('[role="tab"]').forEach((tab) => {
      tab.setAttribute(
        'aria-selected',
        String(tab.classList.contains('rebuy-smart-search-results-page-dropdown__tab--active'))
      );
    });

    resultsRoot
      .querySelectorAll('.rebuy-smart-search-results-page__pagination-arrow')
      .forEach((button, index, arrows) => {
        const label = index === 0 ? previousPageLabel : nextPageLabel;
        const isDisabled = button.classList.contains(
          'rebuy-smart-search-results-page__pagination-arrow--disabled'
        );

        if (label) button.setAttribute('aria-label', label);
        button.disabled = isDisabled;
        button.setAttribute('aria-disabled', String(isDisabled));
      });

    const heading = filters.querySelector(
      '.rebuy-smart-search-results-page-dropdown__filter-section-title'
    );
    const filterButton = filters.querySelector('.rebuy-search-filter > .filter-title');
    const filterMenu = filters.querySelector('.rebuy-filter-select-menu');
    const sortByLabel = filters.querySelector(
      '.rebuy-smart-search-results-page-dropdown__sort-by-label'
    );
    const originalSort = filters.querySelector('#rebuy-smart-search-sort-options');

    if (heading && filterLabel) heading.textContent = filterLabel;
    if (sortByLabel && sortLabel) sortByLabel.textContent = sortLabel;

    if (desktopResultsViewport.matches) {
      filters.dataset.collectionFilterStyle = 'true';
      updateResultsCount(filters, resultsRoot);
      markLiveCollectionFilters(filterMenu);

      if (filterMenu) {
        filters.dataset.collectionFilterOpen = 'true';
        delete filters.dataset.collectionFilterOpening;
      } else if (filterButton && filters.dataset.collectionFilterOpening !== 'true') {
        filters.dataset.collectionFilterOpening = 'true';
        filterButton.click();
        window.setTimeout(() => {
          delete filters.dataset.collectionFilterOpening;
          prepareResultsFilters();
        }, 500);
      }
      return;
    }

    delete filters.dataset.collectionFilterStyle;
    delete filters.dataset.collectionFilterOpening;
    updateResultsCount(filters, resultsRoot);
    prepareMobileFilterButton(filterButton);
    prepareMobileGridControls(filters, resultsRoot);
    updateSearchStickyOffset();
    if (filterButton && filterAndSortLabel) filterButton.setAttribute('aria-label', filterAndSortLabel);

    if (filterMenu && filterButton && filters.dataset.collectionFilterOpen === 'true') {
      delete filters.dataset.collectionFilterOpen;
      filterButton.click();
      return;
    }

    markLiveCollectionFilters(filterMenu);
    prepareMobileFilterMenu(filterMenu, originalSort);
  };

  const focusQuickViewSearch = (searchTerm = '') => {
    const input = document.querySelector(
      '#rebuy-quick-view-dropdown-search .rebuy-quick-view-dropdown__search-input input'
    );
    if (!input) return;

    if (searchTerm && input.value !== searchTerm) {
      const valueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      )?.set;
      valueSetter?.call(input, searchTerm);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    input.focus({ preventScroll: true });
  };

  const openQuickView = (searchTerm = '') => {
    const isQuickViewOpen = Boolean(document.querySelector(quickViewContainerSelector));
    const quickView = window.Rebuy?.SmartSearch?.quickView?.view;
    if (!isQuickViewOpen && typeof quickView?.openQuickView !== 'function') return false;

    // A click during Rebuy startup may already have opened the native modal.
    // Use its close method to release the focus trap and body scroll lock too.
    document.querySelectorAll('details-modal.header__search').forEach((modal) => {
      if (modal.querySelector('details[open]')) modal.close(false);
    });

    if (isQuickViewOpen) {
      focusQuickViewSearch(searchTerm);
      return true;
    }

    document.querySelectorAll('predictive-search[open]').forEach((predictiveSearch) => {
      if (typeof predictiveSearch.close === 'function') predictiveSearch.close();
    });
    quickView.openQuickView();
    window.requestAnimationFrame(() => focusQuickViewSearch(searchTerm));
    window.setTimeout(() => focusQuickViewSearch(searchTerm), 100);
    window.setTimeout(() => focusQuickViewSearch(searchTerm), 250);
    return true;
  };

  const handoffNativeSearch = () => {
    if (!document.querySelector(quickViewRootSelector)) return;

    const nativeSearch = document.querySelector('details-modal.header__search details[open]');
    if (nativeSearch) openQuickView(nativeSearch.querySelector('input[name="q"]')?.value ?? '');
  };

  const getThemeSearchInput = (target) =>
    target instanceof Element
      ? target.closest('.search-modal .search__input, .header-exposed-search__form .search__input')
      : null;

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest?.(themeSearchTriggerSelector);
      if (!trigger || !openQuickView()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      const input = getThemeSearchInput(event.target);
      if (!input || !openQuickView(input.value)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  window.addEventListener(
    'keydown',
    (event) => {
      const quickViewInput = event.target.closest?.(`${quickViewSearchSelector} input`);
      if (!quickViewInput || event.key !== 'Enter') return;

      const searchTerm = quickViewInput.value.trim();
      if (!searchTerm) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(buildProductSearchUrl(searchTerm));
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      const input = getThemeSearchInput(event.target);
      if (!input || !['Enter', 'ArrowDown', ' '].includes(event.key)) return;
      if (!openQuickView(input.value)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const quickViewInput = form.querySelector('.rebuy-quick-view-dropdown__search-input input');
      const searchTerm = quickViewInput?.value.trim() ?? '';
      if (!searchTerm) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(buildProductSearchUrl(searchTerm));
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const select = event.target.closest?.(quickViewSelectSelector);
      if (select) syncQuickViewCta(select);
    },
    true
  );

  const navigateFromQuickViewFooter = (event) => {
    const resultsFooterLink = event.target.closest?.(
      '.rebuy-quick-view-results-footer__link'
    );
    if (!resultsFooterLink) return;

    const quickViewInput = document.querySelector(`${quickViewSearchSelector} input`);
    const searchTerm = quickViewInput?.value.trim() ?? '';

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(
      searchTerm ? buildProductSearchUrl(searchTerm) : resultsFooterLink.href
    );
  };

  window.addEventListener('pointerdown', navigateFromQuickViewFooter, true);
  window.addEventListener('click', navigateFromQuickViewFooter, true);

  document.addEventListener(
    'input',
    (event) => {
      if (event.target.matches?.(resultsPageSearchSelector)) {
        syncResultsSearchClearButton(event.target);
      }

      if (event.target.closest?.(quickViewSearchSelector)) {
        window.requestAnimationFrame(prepareQuickViewResultsFooter);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    async (event) => {
      const gridButton = event.target.closest?.('[data-rebuy-search-grid-columns]');
      if (gridButton && mobileGridViewport.matches) {
        const resultsRoot = gridButton.closest('#rebuy-smart-search-results-dropdown');
        const columns = gridButton.dataset.rebuySearchGridColumns === '1' ? '1' : '2';
        setStoredGridPreference(columns);
        setSearchGridColumns(resultsRoot, columns);
        return;
      }

      const clearSearchButton = event.target.closest?.('.rebuy-results-search-clear');
      if (clearSearchButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const input = document.querySelector(resultsPageSearchSelector);
        if (input) {
          input.value = '';
          syncResultsSearchClearButton(input);
          input.focus({ preventScroll: true });
        }
        return;
      }

      const button = event.target.closest?.(quickViewCtaSelector);
      if (!button) return;

      if (button.dataset.variantValidationBypass === 'true') {
        delete button.dataset.variantValidationBypass;
        return;
      }

      const card = getQuickViewCard(button);
      const select = card?.querySelector('.rebuy-product-options select');
      const variantId = getVariantId(select);
      if (!select || !variantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      const isPurchasable = await checkStorefrontVariant(variantId);
      if (!button.isConnected) return;

      if (getVariantId(select) !== variantId) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        syncQuickViewCta(select);
        return;
      }

      button.disabled = false;
      button.removeAttribute('aria-busy');
      setQuickViewCtaState(select, isPurchasable);

      if (isPurchasable === true) {
        button.dataset.variantValidationBypass = 'true';
        button.click();
        return;
      }

      const productLink = card.querySelector('a[href*="/products/"]');
      if (productLink?.href) window.location.assign(productLink.href);
    },
    true
  );

  const quickViewObserver = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node instanceof Element) {
          prepareQuickViewCtas(node);
          syncQuickViewCtas(node);
          prepareQuickViewSearchHeader(node);
        }
      });
    });
    window.requestAnimationFrame(() => {
      handoffNativeSearch();
      suppressRebuyResultsPage();
      hideQuickViewAttribution();
      prepareResourceContent();
      prepareQuickViewResultsFooter();
      prepareResultsSearchInput();
      prepareResultsFilters();
    });
  });

  handoffNativeSearch();
  suppressRebuyResultsPage();
  hideQuickViewAttribution();
  prepareResourceContent();
  prepareQuickViewResultsFooter();
  prepareQuickViewCtas();
  syncQuickViewCtas();
  prepareQuickViewSearchHeader();
  prepareResultsSearchInput();
  prepareResultsFilters();
  mobileViewport.addEventListener('change', () => prepareQuickViewSearchHeader());
  desktopResultsViewport.addEventListener('change', prepareResultsFilters);
  mobileGridViewport.addEventListener('change', prepareResultsFilters);

  let stickyOffsetFrame = null;
  const requestStickyOffsetUpdate = () => {
    if (stickyOffsetFrame) return;

    stickyOffsetFrame = window.requestAnimationFrame(() => {
      stickyOffsetFrame = null;
      updateSearchStickyOffset();
    });
  };

  window.addEventListener('resize', requestStickyOffsetUpdate);
  window.addEventListener('scroll', requestStickyOffsetUpdate, { passive: true });
  quickViewObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
